/**
 * The tax year waitlist read (PG-13): an ordinary catalog GET for the Federal tax › Tax year waitlist list.
 * The one write the console has here (adding a ticket's requester) is the named exception in
 * `tax-year-waitlist-writes.ts`, a POST on the same path; the mass send, `POST …/notify`, is not reachable.
 * Split out of `catalog.ts` on file-size grounds only.
 *
 * The path has no `:param`, so nothing can ride it as an id and `upstream-siblings.ts` needs no row.
 */
import type { ReadRoute } from "./catalog";

const PAGINATION = ["page", "pageSize"] as const;

export const TAX_YEAR_WAITLIST_READ_ROUTES: readonly ReadRoute[] = [
  {
    path: "/api/admin/tax-year-waitlist",
    query: [...PAGINATION, "status", "taxYear"],
  },
];
